import { type StorageInterface } from '@/common/storageInterface'

export default class BrowserLocalStorage implements StorageInterface {
  _userName: string

  constructor(userName: string) {
    this._userName = userName
  }

  private makeKey(rootKey: string, path: string | null | undefined): string {
    let key = `${rootKey}:${this._userName}`
    if (path) {
      key += `:${path}`
    }
    return key
  }

  readPath(rootKey: string, path: string): Promise<string|null> {
    return Promise.resolve(localStorage.getItem(this.makeKey(rootKey, path)))
  }

  writePath(rootKey: string, path: string, content: string): Promise<void> {
    localStorage.setItem(this.makeKey(rootKey, path), content)
    return Promise.resolve()
  }

  removePath(rootKey: string, path: string | null | undefined): Promise<void> {
    if (!path) {
      // remove all entries for this rootKey
      const prefix = this.makeKey(rootKey, path) + ':'
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i)
        if (key && key.startsWith(prefix)) {
          localStorage.removeItem(key)
        }
      }
    } else {
      localStorage.removeItem(this.makeKey(rootKey, path))
    }

    return Promise.resolve()
  }

  listPath(rootKey: string, path: string): Promise<string[]> {
    const prefix = this.makeKey(rootKey, path)
    const result: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.startsWith(prefix)) {
        result.push(key.substring(prefix.length + 1))
      }
    }
    return Promise.resolve(result)
  }

  supported(): Promise<boolean> {
    try {
      const testKey = '__storage_test__'
      localStorage.setItem(testKey, '1')
      localStorage.removeItem(testKey)
      return Promise.resolve(true)
    } catch {
      return Promise.resolve(false)
    }
  }
}
